import { LOG_PREFIX } from '../consts';

const isSessionStorageEnabled = (): boolean => {
  try {
    return (
      typeof sessionStorage !== 'undefined' &&
      sessionStorage.getItem('debug') === 'true'
    );
  } catch {
    return false;
  }
};

export class DebugLogger {
  private static enabled = false;

  static setEnabled(value: boolean): void {
    this.enabled = value;
    if (value) {
      console.info(`${LOG_PREFIX} Debug logging enabled`);
    }
  }

  static isEnabled(): boolean {
    return this.enabled || isSessionStorageEnabled();
  }

  static info(message: string, ...optional: unknown[]): void {
    if (this.isEnabled()) {
      console.info(`${LOG_PREFIX} ${message}`, ...optional);
    }
  }

  static warn(message: string, ...optional: unknown[]): void {
    if (this.isEnabled()) {
      console.warn(`${LOG_PREFIX} ${message}`, ...optional);
    }
  }

  static error(message: string, error?: unknown): void {
    if (this.isEnabled()) {
      console.error(`${LOG_PREFIX} ${message}`, error);
    }
  }
}

export const setDebugLoggingEnabled = (value: boolean): void => {
  DebugLogger.setEnabled(value);
};

export function log(...args: unknown[]): void {
  if (DebugLogger.isEnabled()) {
    console.debug(LOG_PREFIX, ...args);
  }
}
